import { Link } from "@react-navigation/native";
import {
    Alert,
    Loading,
    Spacer,
    StyleFunction,
    Text,
    useThemedStyle,
} from "@venuepos/react-common";
import { useCustomerLazyQuery } from "graphql-sdk";
import { useTranslation } from "locales";
import React, { useEffect } from "react";
import { View } from "react-native";

export function Customer({ customer }: { customer: string }) {
    const styles = useThemedStyle(styleFunc);
    const [t] = useTranslation();

    const [getCustomer, { error, loading, data }] = useCustomerLazyQuery();

    useEffect(() => {
        if (!customer) {
            return;
        }

        getCustomer({
            variables: {
                id: customer,
            },
        });
    }, [getCustomer, customer]);

    if (!data || !data.customer) {
        return null;
    }

    return (
        <>
            {error ? (
                <Alert type="error">
                    {t(
                        "backoffice.error.from_server",
                        "There was an error: {{errorText}}",
                        {
                            errorText: error.message,
                        }
                    )}
                </Alert>
            ) : loading ? (
                <>
                    <Spacer />
                    <Loading />
                    <Spacer />
                </>
            ) : (
                data && (
                    <View style={styles.row}>
                        <Text style={styles.text}>
                            {t("common.customer", "Customer")}
                        </Text>
                        <Link
                            to={{
                                screen: "CUSTOMER_VIEW",
                                params: { id: data.customer.id },
                            }}
                            style={styles.textLink}
                        >
                            {data.customer.name}
                        </Link>
                    </View>
                )
            )}
        </>
    );
}

const styleFunc: StyleFunction = theme => ({
    row: {
        marginBottom: theme.spacingScale,
    },

    text: {
        ...theme.fonts.regular,
        fontWeight: "bold",
        color: theme.colors.textDark,
        fontSize: 18,
    },

    textLink: {
        ...theme.styles.link,
    },
});
